import { useQueries } from "@tanstack/react-query";
import { graphQLClient } from "../graphqlClient";
import { GET_SCHOOL_DATA } from "../api/queries";
import { useReactQueryErrorReporter } from "./use-error-reporter";

const fetchSchoolById = async (id) => {
  const { getSchoolById } = await graphQLClient.request(GET_SCHOOL_DATA, {
    id,
  });
  return getSchoolById;
};

export const useGetSchoolsByIds = (schoolIds) => {
  const schoolQueries = useQueries({
    queries: schoolIds.map((id) => ({
      queryKey: ["schoolById", id],
      queryFn: () => fetchSchoolById(id),
      enabled: !!id,
    })),
  });

  const isLoading = schoolQueries.some((query) => query.isLoading);
  const isError = schoolQueries.some((query) => query.isError);
  const errors = schoolQueries
    .filter((query) => query.isError)
    .map((query) => query.error?.message);
  const schools = schoolQueries.map((query) => query.data).filter(Boolean);
  // Report all errors together if any exist
  useReactQueryErrorReporter(
    "Error fetching school data",
    isError ? new Error(errors.join(", ")) : null,
  );

  return { schools, isLoading, isError, errors };
};
